import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTagIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 6.40144V1.21875C0 0.545645 0.587617 0 1.3125 0H6.89385C7.24195 1.69019e-06 7.57579 0.128406 7.82193 0.356967L13.6156 5.73679C14.1281 6.21273 14.1281 6.98441 13.6156 7.46035L8.03423 12.643C7.52167 13.119 6.69064 13.119 6.17808 12.643L0.384426 7.26322C0.138284 7.03466 1.82021e-06 6.72467 0 6.40144ZM3.0625 1.625C2.33762 1.625 1.75 2.17065 1.75 2.84375C1.75 3.51686 2.33762 4.0625 3.0625 4.0625C3.78738 4.0625 4.375 3.51686 4.375 2.84375C4.375 2.17065 3.78738 1.625 3.0625 1.625Z",
		fill: "#8EA1B8"
	})
});
export default SvgTagIcon;
